module.exports = __webpack_public_path__ + "static/img/b2.e165061.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/zh/b2.png
// module id = 1anP
// module chunks = 0